/*
 * Returns the precision of a floating number
 */
export function getPrecision(a: number): number {
  if (!Number.isFinite(a)) {
    return 0;
  }

  let e = 1;
  let p = 0;

  while (Math.round(a * e) / e !== a) {
    e *= 10;
    p++;
  }

  return p;
}
